import { AxiosPromise } from "axios";
import { request } from "utils/request";

export const issueApi = {
  findAll: (params?: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/issue",
      params,
    }),
  findOne: (id: number): AxiosPromise<any> =>
    request({
      url: `/v1/admin/issue/${id}`,
      method: "get",
    }),
  create: (data: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/issue",
      data,
      method: "post",
    }),
  update: (id: number, data: any): AxiosPromise<any> =>
    request({
      url: `/v1/admin/issue/${id}`,
      method: "patch",
      data,
    }),
  delete: (id: number): AxiosPromise<any> =>
    request({
      url: `/v1/admin/issue/${id}`,
      method: "delete",
    }),

  upload: (data: any): AxiosPromise<any> =>
    request({
      url: `/v1/admin/issue/upload`,
      method: "post",
      data,
    }),

  count: (): AxiosPromise<any> =>
    request({
      url: `/v1/admin/issue/count/status`,
      method: "get",
    }),

  reject: (id: number, data: any): AxiosPromise<any> =>
    request({
      url: `/v1/admin/issue/${id}/reject`,
      method: "patch",
      data,
    }),

  processing: (id: number): AxiosPromise<any> =>
    request({
      url: `/v1/admin/issue/${id}/process`,
      method: "patch",
    }),

  complete: (id: number, data: any): AxiosPromise<any> =>
    request({
      url: `/v1/admin/issue/${id}/complete`,
      method: "patch",
      data,
    }),

  logs: (params?: any): AxiosPromise<any> =>
    request({
      url: `/v1/admin/issue/logs`,
      method: "get",
      params,
    }),
};
